import * as R from 'ramda'
import _ from 'underscore'

const DEFAULT_MAX_SEATS_COUNT = 5

const strong = (seats, schedule) => {
  const maxOrdersCount = schedule.maxOrdersCount
  const maxSeatsCount = schedule.maxSeatsCount || DEFAULT_MAX_SEATS_COUNT
  if (maxOrdersCount && maxOrdersCount <= schedule.ordersCount) {
    return '一个用户限购 ' + maxOrdersCount + ' 次订单'
  }
  if (maxSeatsCount < seats.length) {
    return `最多只能选择${maxSeatsCount}个座位哦`
  }

  // 不能跨区选座
  const sectionIdList = seats.map(seat => {
    return seat.sectionId
  })
  if (Array.from(new Set(sectionIdList)).length > 1) {
    return '暂不支持跨区选座，请在同一个分区选座'
  }
}
const weak = () => {
  const seatFindFilter = (r, c) => s => {
    return +s.columnNum === c && +s.rowNum === r
  }
  return (all, selected) => {
    // 是否可选
    const isSelectable = (row, column) => {
      const found = R.find(seatFindFilter(row, column))(all)
      if (!found) {
        return false
      }
      if (found.isOccupied || found.isBroken) {
        return false
      }
      return true
    }
    // 是否是空闲位置
    const isIdle = (row, column) => {
      if (!isSelectable(row, column)) {
        return false
      }
      if (R.find(seatFindFilter(row, column))(selected)) {
        return false
      }
      return true
    }
    // 是否留有空位
    const isSkip = (left, right) => {
      const row = +left.rowNum
      const middle = R.range(+left.columnNum + 1, +right.columnNum)
      return !!R.find(column => {
        return isIdle(row, column)
      })(middle)
    }
    // 是否在边缘
    const isEdge = seat => {
      const row = +seat.rowNum
      const column = +seat.columnNum
      return !isSelectable(row, column + 1) || !isSelectable(row, column - 1)
    }
    // 是否选择某个位置而导致非法留空
    const isCauseSkip = seat => {
      const row = +seat.rowNum
      const column = +seat.columnNum
      // 旁边的位置可选，但是旁边的第二个位置不可选
      if (isIdle(row, column + 1) && !isIdle(row, column + 2)) {
        return true
      }
      if (isIdle(row, column - 1) && !isIdle(row, column - 2)) {
        return true
      }
      return false
    }

    // 计算是否跳座位选座
    // 跟据行进行分组，并以列排序

    let rows = R.groupBy(s => {
      return s.rowNum
    })(selected)
    rows = R.map((seats, row) => {
      // console.log('seat before sort ', seats)
      const sortedSeat = R.sort((a, b) => {
        return a.columnNum - b.columnNum
      })(seats)
      // console.log('sorted seats ', sortedSeat )
      return sortedSeat
    })(rows)

    // if (R.keys(rows).length > 2) {
    //   return `无法选择超过两排的座位`
    // }
    /**
     * rows = {
     *    1: [{
     *        columnNum: 1
     *        rowNum: 1
     *      }]
     *  }
     */
    let hasSkip = !!_.find(rows, row => {
      return _.find(row, (left, index) => {
        return _.find(_.rest(row, index + 1), right => {
          return isSkip(left, right)
        })
      })
    })

    // console.log(' hasSkip ', hasSkip)
    if (hasSkip) {
      return '座位间请不要留出空位噢'
    }

    const hasCauseSkip = !!_.find(rows, seats => {
      if (isEdge(_.first(seats)) || isEdge(_.last(seats))) {
        return false
      }
      const ret = _.find(seats, isCauseSkip)
      return !!ret
    })
    if (hasCauseSkip) {
      return '选座时请不要留出单个空座噢'
    }
    return
  }
}

const maxLine = () => {
  return (all, selected) => {
    let rows = R.groupBy(s => {
      return s.rowNum
    })(selected)
    rows = R.map((seats, row) => {
      // console.log('seat before sort ', seats)
      const sortedSeat = R.sort((a, b) => {
        return a.columnNum - b.columnNum
      })(seats)
      // console.log('sorted seats ', sortedSeat )
      return sortedSeat
    })(rows)

    if (R.keys(rows).length > 2) {
      return `无法选择超过两排的座位`
    }
  }
}

export default {
  strong,
  weak,
  maxLine,
}
